import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../service/api_service';
import { Subscription } from 'rxjs';
import * as $ from 'jquery';


@Component({
  selector: 'app-employeewisechemist',
  template: require('./employeewisechemist.component.html'),
  styles: []
})
export class EmployeeWiseChemistComponent implements OnInit {

  private columnDefs;
  private rowHeight;
  api: any;
  busy: Subscription;
  columnApi: any;
  defaultColDefine;
  private gridColumnApi;
  private detailCellRendererParams;
  EmpWiseChemsistData: any;
  EmpDetailsList: any;
  headQuarterList: any;
  stateList: any;
  token: any;
  ClientCode: any;
  hq: any;
  stateId: any;
  status: any;


  static parameters = [ApiService]

  constructor(
    private apiService: ApiService

  ) {
    this.columnDefs = [
      { headerName: 'S.No.', valueGetter: "node.rowIndex + 1", width: 80 },
      { headerName: 'Employee Name', field: "Client_Name" },
      { headerName: 'Employee Code', field: "Client_Code" },
      // { headerName: 'Designation', field: "Designation" },
      // { headerName: 'Manager', field: "Manager" },
      { headerName: 'Head Qtr', field: "HQName" },
      { headerName: 'State', field: "StateName" },
      { headerName: 'No of Chemist', field: "ChemsitCount" },
      { headerName: 'Total Mobile No. Count', field: "MobileCount" },
      { headerName: 'Total Phone No. Count', field: "PhoneCount" },
      { headerName: 'Total Email Count', field: "EmailCount" },
      { headerName: 'Status', field: "status" },
    ];
    this.rowHeight = 50;
    this.defaultColDefine = { resizable: true };

  }


  ngOnInit() {
    $('#filter-option').trigger('click');
    this.ClientCode = 0;
    this.hq = 0;
    this.stateId = 0;
    this.status = "-1";
    this.token = JSON.parse(sessionStorage.getItem("currentUser"));
    this.getEmpDetails();
    this.getHeadQuarterList();
    this.getState();
  }

  onGridReady = (params) => {
    this.api = params.api;
    this.gridColumnApi = params.columnApi;
    this.api.hideOverlay();

  }

  onBtnExport() {
    this.api.exportDataAsExcel({ fileName: 'EmpWiseChemist' });
  }

  onFilterTextBoxChanged() {
    this.api.setQuickFilter(document.querySelector<HTMLInputElement>('#filter-text-box')!.value);
    this.api.refreshCells();
  }


  getEmpDetails() {
    var data = {
      Id: this.token.id
    };
    this.apiService.getEmpDetails(data).subscribe((res: any) => {
      this.EmpDetailsList = res.data;
    })
  }


  getState() {
    this.apiService.getState().subscribe((res: any) => {
      this.stateList = res.data;
    })
  }

  getHeadQuarterList() {
    this.apiService.getHeadQuarterList().subscribe((res: any) => {
      this.headQuarterList = res.data;
    })
  }


  getEmpWiseChemsitData() {
    var data = {
      loginId: this.token.id,
      ClientCode: this.ClientCode,
      hq: this.hq,
      state: this.stateId,
      status: this.status
    };
    console.log(data);
    this.busy = this.apiService.getEmpWiseChemsitData(data).subscribe((res: any) => {
      this.EmpWiseChemsistData = res;

    })
  }

}
